<template>
  <div class="modal-card" style="width: 700px">
    <div class="modal-card-head">
      <p class="modal-card-title">Subscription History</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </div>
    <div class="modal-card-body" style="position: relative">
      <b-loading v-model="subscriptionsLoading" :is-full-page="false" />
      <template v-if="subscriptionsForTerminal.length">
        <div class="mb-4" v-for="sub in subscriptionsForTerminal" :key="sub.id">
          <detail-field-2>
            <template v-slot:label>Product Code</template>
            <template v-slot:value>{{ sub.productCode }}</template>
          </detail-field-2>
          <detail-field-2>
            <template v-slot:label>Description</template>
            <template v-slot:value>{{ sub.description }}</template>
          </detail-field-2>
          <detail-field-2>
            <template v-slot:label>Start Date</template>
            <template v-slot:value>{{ format(addMinutes(new Date(sub.startDate), new Date(sub.startDate).getTimezoneOffset()), 'yyyy-MM-dd') }}</template>
          </detail-field-2>
          <detail-field-2>
            <template v-slot:label>End Date</template>
            <template v-slot:value>{{ format(addMinutes(new Date(sub.endDate), new Date(sub.endDate).getTimezoneOffset()), 'yyyy-MM-dd') }}</template>
          </detail-field-2>
          <detail-field-2 v-if="$hasRole('Super User,Kymeta Admin,Product Support')">
            <template v-slot:label>Supported Networks</template>
            <template v-slot:value>{{ sub.networkIdentifiers.join(', ') }}</template>
          </detail-field-2>
          <detail-field-2 v-if="$hasRole('Super User,Kymeta Admin,Sales Support')">
            <template v-slot:label>Salesforce ID</template>
            <template v-slot:value>{{ sub.salesforceObjectId }}</template>
          </detail-field-2>
        </div>
      </template>
      <p v-else class="my-4">No past subscriptions found for this terminal.</p>
    </div>
    <footer class="modal-card-foot">
      <b-button @click="$emit('close')">Close</b-button>
    </footer>
  </div>
</template>
<script setup>
import { format, addMinutes } from 'date-fns';
import { defineProps, ref, onMounted } from 'vue';
import { useSubscriptions2Store } from '../../subscriptions2/subscriptions2-store';

const props = defineProps(['terminalId', 'subHistory']);
const subscriptionsForTerminal = ref([]);
const subscriptionsLoading = ref(false);
const store = useSubscriptions2Store();

const loadSubscriptions = async () => {
  subscriptionsLoading.value = true;
  if (props.terminalId && props.subHistory) {
    const r = await store.dispatch('fetchSubscriptionsByIds', props.subHistory.map(h => h.id));
    if (r) {
      subscriptionsForTerminal.value = r;
    }
  }
  subscriptionsLoading.value = false;
}

onMounted(async () => {
  await loadSubscriptions();
})
</script>
